module.exports = __webpack_public_path__ + "img/wrong-face.cc0623bb.jpg";